/** A deactivated person's name: plain and muted, not a link, with the reason it isn't tappable. */
export function DeactivatedName(props: { name: string }) {
  return (
    <span className="muted-name">
      {props.name} <span className="muted">(Deactivated)</span>
    </span>
  );
}
